import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_auth = _resolveComponent("auth")!

  return (_openBlock(), _createBlock(_component_auth, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo-section" }, [
            _createElementVNode("img", {
              src: "/logo.svg",
              alt: "Logo",
              class: "logo"
            })
          ], -1)),
          _createVNode(_component_el_form, {
            "label-position": "top",
            ref: "signInFormRef",
            model: _ctx.signInData,
            rules: _ctx.rules,
            onSubmit: _withModifiers(_ctx.signIn, ["prevent"]),
            class: "login-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Email",
                prop: "email",
                error: _ctx.formErrors.email
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.signInData.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signInData.email) = $event)),
                    placeholder: "Enter your email",
                    "prefix-icon": "Message",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_el_form_item, {
                prop: "password",
                label: "Password",
                error: _ctx.formErrors.password
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.signInData.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signInData.password) = $event)),
                    placeholder: "Enter your password",
                    "prefix-icon": "Lock",
                    "show-password": "",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "submit-btn",
                    type: "primary",
                    "native-type": "submit",
                    loading: _ctx.isLoading,
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Sign in"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, "Signing in..."))
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "onSubmit"])
        ])
      ])
    ]),
    _: 1
  }))
}